import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/** Registrul Art. 23 NIS2 pe tichet (`Easeedesk\Nis2\Art23Reports`). */
export type Nis2StageKey = 'early' | 'notification' | 'final'

export type Nis2Stage = {
  key: Nis2StageKey
  label: string
  due: string
  /** Finalul, inainte de notificare: socotit de la termenul ei, nu de la trimitere. */
  estimated: boolean
  sent_at: string | null
  state: 'open' | 'overdue' | 'sent' | 'sent_late'
  minutes_left: number | null
  can_send: boolean
}

export type Nis2Report = {
  aware_at: string
  marked_at: string
  stages: Nis2Stage[]
  drafts: Record<Nis2StageKey, string>
  can_remove: boolean
}

export type TicketNis2 = { ready: boolean; canEdit: boolean; report: Nis2Report | null }

const base = (ticketId: number) => `/easeedesk/tickets/${ticketId}/nis2`

export function ticketNis2Query(ticketId: number) {
  return queryOptions({
    queryKey: ['easeedesk', 'ticket', ticketId, 'nis2'],
    queryFn: () => apiGet<TicketNis2>(base(ticketId)),
    enabled: ticketId > 0,
  })
}

/** `awareAt` gol = acum. */
export function markNis2(ticketId: number, awareAt: string) {
  return apiPost<TicketNis2>(base(ticketId), { aware_at: awareAt })
}

export function markNis2Sent(ticketId: number, stage: Nis2StageKey) {
  return apiPost<TicketNis2>(`${base(ticketId)}/sent`, { stage })
}

export function removeNis2(ticketId: number) {
  return apiPost<TicketNis2>(`${base(ticketId)}/remove`, {})
}
